export type ManualBankAccountValues = {
  name: string;
  account_number: string;
  routing_number: string;
  bank_details_entity_name: string;
  address: string;
  is_confirmed: boolean;
};

export const MANUAL_BANK_ACCOUNT_INITIAL_VALUES: ManualBankAccountValues = {
  name: "",
  account_number: "",
  routing_number: "",
  bank_details_entity_name: "",
  address: "",
  is_confirmed: false,
};
